
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiLguJXguYjguLMiLCJBdmVyYWdlIjoi4LiE4LmI4Liy4LmA4LiJ4Lil4Li14LmI4LiiIiwiSGlnaCI6IuC4quC4ueC4hyJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiLguJXguYjguLMiLCJBdmVyYWdlIjoi4LiE4LmI4Liy4LmA4LiJ4Lil4Li14LmI4LiiIiwiSGlnaCI6IuC4quC4ueC4hyJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJSZW5kYWgiLCJBdmVyYWdlIjoiUmF0YS1yYXRhIiwiSGlnaCI6IlRpbmdnaSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJSZW5kYWgiLCJBdmVyYWdlIjoiUmF0YS1yYXRhIiwiSGlnaCI6IlRpbmdnaSJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiLguJXguYjguLMiLCJBdmVyYWdlIjoi4LiE4LmI4Liy4LmA4LiJ4Lil4Li14LmI4LiiIiwiSGlnaCI6IuC4quC4ueC4hyJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiLguJXguYjguLMiLCJBdmVyYWdlIjoi4LiE4LmI4Liy4LmA4LiJ4Lil4Li14LmI4LiiIiwiSGlnaCI6IuC4quC4ueC4hyJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJSZW5kYWgiLCJBdmVyYWdlIjoiUmF0YS1yYXRhIiwiSGlnaCI6IlRpbmdnaSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJSZW5kYWgiLCJBdmVyYWdlIjoiUmF0YS1yYXRhIiwiSGlnaCI6IlRpbmdnaSJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJMb3ciLCJBdmVyYWdlIjoiQXZlcmFnZSIsIkhpZ2giOiJIaWdoIn0%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJbxYHDtsO2w7bFtV0iLCJBdmVyYWdlIjoiW%2BG6rOG5veG6veG6vcWZxIPEg8Sj4bq94bq9XSIsIkhpZ2giOiJb4biow6zDrMOsxKPhuKldIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJMb3ciOiJbxYHDtsO2w7bFtV0iLCJBdmVyYWdlIjoiW%2BG6rOG5veG6veG6vcWZxIPEg8Sj4bq94bq9XSIsIkhpZ2giOiJb4biow6zDrMOsxKPhuKldIn0%3D!"
        )
      )
      });
  
      export { translations as default };
    